import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_VEHICLE_URL;

// GET the reminder config for the client
export function getReminderConfig(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vehicle-maintenance-schedules-config`, "GET");
}

// SAVE (add or update) the reminder config
export function addReminderConfig(body?: any): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}vehicle-maintenance-schedules-config`,
    "POST",
    body
  );
}

// GET conflicts for a vehicle
export function getVehicleConflicts(
  vehicleId?: number,
  contractStartDate?: string, // ISO string
  contractEndDate?: string // ISO string
): Promise<ApiResponse> {
  const params: any = {};
  if (vehicleId) params.vehicleId = vehicleId;
  if (contractStartDate) params.contractStartDate = contractStartDate;
  if (contractEndDate) params.contractEndDate = contractEndDate;

  return makeApiCall(
    `${BASE_URL}vehicle-maintenance-schedules-conflict`,
    "GET",
    params
  );
}
